import { ReactNode, Fragment } from 'react'

import { instanceOfAnchorRef } from 'api/utils'
import { TableOfContentItem } from 'interfaces/types'

import {
  StyledTableOfContent,
  StyledSeparator,
  StyledContent,
  StyledRefContent,
} from './index.styled'

export type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
  contentClassName?: string
  contents: Array<TableOfContentItem>
  separator?: ReactNode | string
}

const TableOfContent = ({
  className,
  size = 'md',
  contents,
  separator = '|',
  contentClassName,
}: Props) => {
  return (
    <StyledTableOfContent className={className} data-size={size}>
      {contents.map((content, index) => {
        if (!content) return null
        return (
          <Fragment key={index}>
            {instanceOfAnchorRef(content) ? (
              <StyledRefContent
                href={`#${content.id}`}
                className={contentClassName}
              >
                {content.label}
              </StyledRefContent>
            ) : (
              <StyledContent className={contentClassName}>
                {content}
              </StyledContent>
            )}
            {index + 1 < contents.length && (
              <StyledSeparator>{separator}</StyledSeparator>
            )}
          </Fragment>
        )
      })}
    </StyledTableOfContent>
  )
}

export { TableOfContent }
